import { axiosClient } from '../axiosClient';
import type { Permission } from './auth';

export interface TeamMember {
  id: number;
  name: string;
  email: string;
  roles: string[];
  permissions: Permission[];
  is_active: boolean;
  must_change_password: boolean;
  created_at?: string;
  last_login?: string;
}

export interface RoleOption {
  key: string;
  label: string;
}

export interface CreateTeamMemberData {
  name: string;
  email: string;
  password: string;
  roles: string[];
}

export interface UpdateTeamMemberData {
  name?: string;
  roles?: string[];
  is_active?: boolean;
}

export const teamApi = {
  list: async (): Promise<TeamMember[]> => {
    const res = await axiosClient.get<{ managers: TeamMember[] }>('/manager/team');
    return res.data.managers ?? [];
  },
  roles: async (): Promise<RoleOption[]> => {
    const res = await axiosClient.get<{ roles: RoleOption[] }>('/manager/team/roles');
    return res.data.roles ?? [];
  },
  create: async (data: CreateTeamMemberData): Promise<TeamMember> => {
    const res = await axiosClient.post<{ manager: TeamMember }>('/manager/team', data);
    return res.data.manager;
  },
  update: async (id: number, data: UpdateTeamMemberData): Promise<TeamMember> => {
    const res = await axiosClient.patch<{ manager: TeamMember }>(`/manager/team/${id}`, data);
    return res.data.manager;
  },
  deactivate: async (id: number): Promise<void> => {
    await axiosClient.delete(`/manager/team/${id}`);
  },
};
